import { OnOrder } from 'services/api/pay';
import type { OrderInfo } from './components/PayModal';

interface HandleOrderDependencies {
  orderAndPay: OnOrder;
  showPayModal: (info: OrderInfo) => void;
  onError: () => void;
}

export const handleOrder = (
  info: Parameters<OnOrder>[0],
  { orderAndPay, showPayModal, onError }: HandleOrderDependencies,
) => {
  const isSubscription = 'subscription' in info && info.subscription === true;

  return orderAndPay(info)
    .then((res) => {
      // 订阅（连续包月）由订阅弹窗自行处理 Stripe 支付，不打开 PayModal
      if (isSubscription) {
        return res;
      }
      showPayModal({
        ...info,
        ...res,
      });
      return res;
    })
    .catch((error) => {
      onError();
      // 订阅流程需要由调用方收尾 loading、轮询和支付弹窗状态。
      if (isSubscription) {
        throw error;
      }
    });
};
